import React, { useEffect, useRef, useState } from "react";
import "./index.scss";
import {
    Form,
    Input,
    Button,
    Dialog,
    DatePicker,
    ImageUploader,
    Toast,
    Popup,
    CheckList,
    TextArea,
    VirtualInput,
    NavBar,
} from 'antd-mobile'
import dayjs from 'dayjs'
import type { DatePickerRef } from 'antd-mobile/es/components/date-picker'
import { imageUpdate } from "@/utils/imageUpdate";
import { getGarmentTypeList } from "../Home/api";
import { garmentTypeCreate } from "./api";
import { getQuery } from "@/utils/operationUrl";

const Garment = () => {
    const onFinish = (values: any) => {
        const imageUrl = from.current?.getFieldValue('imageUrl');
        const type = from.current?.getFieldValue('type');
        // Dialog.alert({
        //     content: <pre>{JSON.stringify({ ...values, imageUrl, type }, null, 2)}</pre>,
        // })
        garmentTypeCreate(({
            ...values,
            imageUrl: imageUrl?.[0]?.url,
            type,
        })).then(res => {
            if (!res.code) {
                Toast.show('创建成功')
                window.location.href = '/#/home'
            } else {
                Toast.show({ icon: 'fail', content: res.msg || '创建失败' })
            }
        })
    }
    const [visible, setVisible] = useState(false);
    const [garmaentTypeList, setGarmentTypeList] = useState([])
    const [idToLabel, setIdToLabel] = useState('')
    const from = useRef<any>({})
    const {type} =getQuery()
    const openGarmentTypeList = () => {
        if(type)return // 编辑态不触发编辑
        setVisible(true)
    }
    useEffect(() => {
        getGarmentTypeList().then((res) => {
            setGarmentTypeList(res.data || [])
            res.data.length && setIdToLabel(res.data?.reduce((prev: any, next: any) => {
                prev[next.id] = next.name
                return prev
            }, {}))
            from.current?.setFieldValue('type', type)
        });
    }, [])
    return (
        <div className="garment">
            <Form
                name='form'
                ref={from}
                onFinish={onFinish}
                footer={
                    <Button className="garment-btn" block type='submit' size='large'>
                        提交
                    </Button>
                }
            >
                <NavBar style={{color:'#685632'}} onBack={() => {
                    window.location.href = '/#/home'
                }}>{type ? '编辑衣服' : '新增衣服'}</NavBar>

                <Form.Item name='name' label='名称'>
                    <Input placeholder='请输入名称' />
                </Form.Item>
                <Form.Item label='所属分类' shouldUpdate={() => true}>
                    {({ getFieldValue, setFieldValue }) => {
                        const value = getFieldValue('type')
                        return (
                            <div>
                                <VirtualInput disabled={!!type} value={idToLabel[value] || ''} onClick={openGarmentTypeList}
                                    placeholder='请输入内容'
                                />
                                <Popup
                                    showCloseButton
                                    visible={visible}
                                    onMaskClick={() => {
                                        setVisible(false)
                                    }}
                                    onClose={() => {
                                        setVisible(false)
                                    }}
                                    position='bottom'
                                    bodyStyle={{
                                        borderTopLeftRadius: '8px',
                                        borderTopRightRadius: '8px',
                                        height: '40vh',
                                    }}
                                >
                                    <div style={{ height: '40vh', color: '#a0854a' }}>
                                        <div style={{ height: '5rem' }}></div>
                                        <div style={{ overflow: 'auto', height: `calc( 40vh - 5rem )` }}>
                                            <CheckList
                                                value={value ? [value] : []}
                                                onChange={val => {
                                                    console.log(22);

                                                    setFieldValue('type', val[0])
                                                    setVisible(false)
                                                }}
                                            >
                                                {garmaentTypeList?.map((item: any) => (
                                                    <CheckList.Item key={`${item.id}`} value={item.id}>
                                                        {item.name}
                                                    </CheckList.Item>
                                                ))}
                                            </CheckList>
                                        </div>

                                    </div>
                                </Popup>
                            </div>
                        )
                    }}
                </Form.Item>

                <Form.Item
                    name='buyingTime'
                    label='购买时间'
                    trigger='onConfirm'
                    className="garment-time"
                    onClick={(e, datePickerRef: RefObject<DatePickerRef>) => {
                        datePickerRef.current?.open()
                    }}
                >
                    <DatePicker>
                        {value =>
                            value ? dayjs(value).format('YYYY-MM-DD') : '请选择日期'
                        }
                    </DatePicker>
                </Form.Item>
                <Form.Item shouldUpdate={() => true} noStyle>
                    {({ getFieldValue, setFieldValue }) => {
                        return (
                            <Form.Item name='imageUrl' label='衣服图片' >
                                <ImageUploader
                                    value={getFieldValue('imageUrl')}
                                    defaultValue={getFieldValue('imageUrl')}
                                    onChange={(val) => {
                                        const lastUrl = val[val?.length - 1] || {}
                                        setFieldValue('imageUrl', [lastUrl])
                                    }}
                                    upload={async (file) => {
                                        console.log(file, 'eee');
                                        const res = await imageUpdate({
                                            file: file,
                                            config: { headers: { 'Content-Type': 'application/octet-stream', }, onUploadProgress: () => { }, },
                                        })
                                        const { code, data, msg } = res.data
                                        if (code !== 0) {
                                            Toast.show(msg)
                                            return { url: '' }
                                        }
                                        return { url: data, }
                                    }}
                                    // beforeUpload={beforeUpload}
                                    deletable={false}
                                    maxCount={2}
                                    showUpload={true}
                                />
                            </Form.Item>
                        )
                    }}
                </Form.Item>
                <Form.Item name='remark' label='衣服简介'>
                    <TextArea autoSize={{ minRows: 3, maxRows: 5 }} placeholder='请输入名称' />
                </Form.Item>
            </Form>
        </div>
    )
}

export default Garment;
